import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CartButton from '../../components/feature/CartButton';

export default function TestimonialsPage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [playingVideo, setPlayingVideo] = useState<number | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const testimonials = [
    {
      id: 1,
      name: 'Adebayo Johnson',
      image: 'https://public.readdy.ai/ai/img_res/09a99d9b78cd9a6cc35fc7598c581a52.jpg',
      rating: 5,
      text: 'These herbal products have transformed my health! After just 3 weeks of using Clean Detox, I feel more energized and my digestion has improved significantly.',
    },
    {
      id: 2,
      name: 'Chioma Okafor',
      image: 'https://readdy.ai/api/search-image?query=confident%20Nigerian%20man%20in%20his%2040s%20genuine%20smile%20healthy%20appearance%20simple%20white%20background%20professional%20portrait%20photography%20authentic%20real%20person&width=400&height=500&seq=testimonial-2-authentic&orientation=portrait',
      rating: 5,
      text: 'Vita Trace has been a game-changer for my immune system. I haven\'t been sick since I started taking it 4 months ago. Highly recommend!',
    },
    {
      id: 3,
      name: 'Emeka Nwankwo',
      image: 'https://readdy.ai/api/search-image?query=joyful%20Nigerian%20woman%20in%20her%2050s%20warm%20smile%20radiant%20healthy%20skin%20simple%20white%20background%20professional%20portrait%20photography%20authentic%20real%20person&width=400&height=500&seq=testimonial-3-authentic&orientation=portrait',
      rating: 5,
      text: 'I was skeptical at first, but the Noni Juice has helped with my joint pain tremendously. Natural healing really works!',
    },
  ];

  const videoTestimonials = [
    {
      id: 1,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20woman%20in%20her%2040s%20speaking%20confidently%20to%20camera%20in%20bright%20living%20room%20natural%20daylight%20authentic%20testimonial%20video%20screenshot%20warm%20smile%20wellness%20transformation%20story&width=600&height=400&seq=video-testimonial-woman-1-unique&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/1821CeBCetOaTHSLWAklXiKkGkPgCh2oG/preview',
      title: 'Client testimony'
    },
    {
      id: 2,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20man%20in%20his%2050s%20sharing%20health%20success%20story%20outdoors%20natural%20sunlight%20genuine%20expression%20testimonial%20video%20screenshot%20wellness%20journey%20authentic%20documentary%20style&width=600&height=400&seq=video-testimonial-man-2-unique&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/1_2UO_b0KY7UU-5fZtPjkga6k0X-EkNJN/preview',
      title: 'Client testimony'
    },
    {
      id: 3,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20woman%20in%20her%2030s%20happy%20expression%20sitting%20in%20modern%20office%20natural%20lighting%20testimonial%20video%20screenshot%20health%20transformation%20story%20professional%20setting%20authentic&width=600&height=400&seq=video-testimonial-woman-3-unique&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/14Fc1CuAzsvMSdsv1k89t6EYoSP6j59_b/preview',
      title: 'Client testimony'
    },
    {
      id: 4,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20man%20in%20his%2030s%20confident%20expression%20standing%20in%20home%20kitchen%20bright%20morning%20light%20testimonial%20video%20screenshot%20health%20success%20story%20casual%20authentic%20setting&width=600&height=400&seq=video-testimonial-man-4-unique&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/162TNpVbP-2HjESFCC18HRLqx010R3aKs/preview',
      title: 'Client testimony'
    },
    {
      id: 5,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20woman%20in%20her%2050s%20joyful%20smile%20sitting%20on%20couch%20at%20home%20warm%20afternoon%20light%20testimonial%20video%20screenshot%20wellness%20journey%20transformation%20authentic%20comfortable%20setting&width=600&height=400&seq=video-testimonial-woman-5-unique&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/15DIIAgNDJF92BJl9hhgggRl-qrRgOa7T/preview',
      title: 'Client testimony'
    },
    {
      id: 6,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20man%20in%20his%2040s%20genuine%20smile%20standing%20in%20garden%20outdoor%20natural%20setting%20testimonial%20video%20screenshot%20health%20transformation%20story%20authentic%20documentary%20photography&width=600&height=400&seq=video-testimonial-man-6-unique&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/1-9NSbe-Vf8pgOV-5ggFV0WB50_rhTwnj/preview',
      title: 'Client testimony'
    },
    {
      id: 7,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20woman%20in%20her%2040s%20confident%20expression%20sitting%20at%20dining%20table%20home%20interior%20natural%20window%20light%20testimonial%20video%20screenshot%20wellness%20success%20story%20authentic%20lifestyle%20photography&width=600&height=400&seq=video-testimonial-woman-7-unique&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/17jBSvZG6yGHbERYaeX0AdGdP-MEseg8j/preview',
      title: 'Client testimony'
    },
    {
      id: 8,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20man%20in%20his%2060s%20warm%20smile%20sitting%20in%20comfortable%20armchair%20home%20library%20setting%20soft%20natural%20light%20testimonial%20video%20screenshot%20health%20journey%20authentic%20mature%20wisdom&width=600&height=400&seq=video-testimonial-man-8-unique&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/1U7mhJaES3MU76RDC6LGHOy5TGiOolTY1/preview',
      title: 'Client testimony'
    },
    {
      id: 9,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20woman%20in%20her%2030s%20radiant%20smile%20standing%20in%20modern%20workspace%20bright%20office%20environment%20testimonial%20video%20screenshot%20professional%20wellness%20transformation%20authentic%20confident%20expression&width=600&height=400&seq=video-testimonial-woman-9-unique&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/1qHBnd0bbzskf_dvaxDv1D7JefDlarhH9/preview',
      title: 'Client testimony'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img
                src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg"
                alt="Organic Natural Solution Logo"
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                About
              </Link>
              <Link
                to="/products"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Products
              </Link>
              <Link
                to="/testimonials"
                className="text-sm font-medium text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Testimonials
              </Link>
              <Link
                to="/blog"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Blog
              </Link>
              <Link
                to="/contact"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Contact
              </Link>
              <CartButton />
            </div>
            <div className="flex md:hidden items-center gap-4">
              <CartButton />
              <button
                className="cursor-pointer"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <i
                  className={`${
                    mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
                  } text-2xl text-gray-900`}
                ></i>
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link
                to="/"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                About
              </Link>
              <Link
                to="/products"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Products
              </Link>
              <Link
                to="/testimonials"
                className="block text-sm font-medium text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Testimonials
              </Link>
              <Link
                to="/blog"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Blog
              </Link>
              <Link
                to="/contact"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Customer <span className="text-teal-600">Success Stories</span>
            </h1>
            <p className="text-xl text-gray-600">
              Real people, real results. See how our natural remedies have
              transformed lives
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { number: '10,000+', label: 'Happy Customers' },
              { number: '4.8/5', label: 'Average Rating' },
              { number: '2,500+', label: '5-Star Reviews' },
              { number: '98.7%', label: 'Would Recommend' }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-5xl md:text-6xl font-bold text-teal-600 mb-2">
                  {stat.number}
                </div>
                <p className="text-sm text-gray-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="aspect-[4/5]">
                  <img
                    src={testimonial.image}
                    alt="Client Testimonial"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <p className="text-sm text-gray-600 mb-4">Client testimonial after taking our natural products</p>
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i
                        key={i}
                        className="ri-star-fill text-yellow-500 text-lg"
                      ></i>
                    ))}
                  </div>
                  <p className="text-gray-600 leading-relaxed text-sm">
                    {testimonial.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Testimonials Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Video Stories
            </h2>
            <p className="text-lg text-gray-600">
              Hear directly from our customers
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {videoTestimonials.map((video) => (
              <div
                key={video.id}
                className="rounded-3xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
              >
                {playingVideo === video.id ? (
                  <div className="aspect-video">
                    <iframe
                      width="100%"
                      height="100%"
                      src={video.videoUrl}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                ) : (
                  <div 
                    className="aspect-video relative cursor-pointer group"
                    onClick={() => setPlayingVideo(video.id)}
                  >
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/30 flex items-center justify-center group-hover:bg-black/40 transition-colors">
                      <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                        <i className="ri-play-fill text-3xl text-teal-600"></i>
                      </div>
                    </div>
                  </div>
                )}
                <div className="bg-white p-6">
                  <p className="text-gray-900 font-medium">{video.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-teal-600">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready to Start Your Journey?
          </h2>
          <p className="text-xl mb-8 text-teal-50">
            Join thousands of satisfied customers who have transformed their
            health naturally
          </p>
          <Link
            to="/products"
            className="inline-block bg-white text-teal-600 px-10 py-4 rounded-full font-medium hover:bg-gray-100 transition-colors whitespace-nowrap"
          >
            Shop Now
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-teal-600 text-white py-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=natural%20herbal%20leaves%20botanical%20pattern%20elegant%20minimalist%20design%20soft%20organic%20shapes%20wellness%20theme%20decorative%20background%20simple%20clean%20aesthetic&width=1920&height=600&seq=footer-bg-pattern&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <img
                src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg"
                alt="Organic Natural Solution Logo"
                className="h-12 w-auto mb-6"
              />
              <p className="text-teal-50 leading-relaxed mb-6">
                Dedicated to providing the highest quality herbal remedies that
                honor traditional wisdom while meeting modern wellness needs.
              </p>
              <div className="flex gap-4">
                <a href="https://www.instagram.com/healthyliving.products?igsh=NGl6a3oxZXhrcmxr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://www.facebook.com/share/1CKjLukjVr/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
              </div>
            </div>

            <div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">
                  LOCATION
                </h4>
                <p className="text-teal-50">
                  #2 Allen Avenue Near Tonyin Roundabout, Ikeja, Lagos -
                  Nigeria
                </p>
              </div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">PHONE</h4>
                <p className="text-teal-50">+234 815 435 8746</p>
                <p className="text-teal-50">+234 913 789 7299</p>
              </div>
              <div>
                <h4 className="text-xs font-bold uppercase mb-3">EMAIL</h4>
                <p className="text-teal-50">healthyliving.hello@gmail.com</p>
              </div>
            </div>

            <div>
              <div className="rounded-2xl overflow-hidden h-80">
                <img 
                  src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/6686b80771a03e2f4f8c9b19d31144a1.jpeg" 
                  alt="Organic Natural Solution" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8">
            <p className="text-sm text-teal-50 text-center">
              © 2025 Organic Natural Solution. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <button
        onClick={() => window.open('https://wa.me/2348154358746', '_blank')}
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center z-50 transition-all hover:scale-110 cursor-pointer"
        aria-label="Contact us on WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </button>
    </div>
  );
}
